import { connectHook } from 'app/common/components/connect-hook';
import { Link } from '../link/link.js';
import { useProjectLink } from './project-link-hook.js';

export default connectHook(Link, useProjectLink);
